import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueTilt from 'vue-tilt.js'
import VueTimeago from 'vue-timeago'
import * as timeago from 'timeago.js';
import VueMask from 'v-mask';

Vue.use(
  VueMask, {
    placeholders: {
      W: /[1-9]/,         // define new placeholder
    }
  }
);
Vue.directive('mask', VueMask.VueMaskDirective);
Vue.filter('VMask', VueMask.VueMaskFilter)

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  converter(date, locale, converterOptions) {
    const { includeSeconds, addSuffix = true } = converterOptions
    return timeago.format(date);
  }
})


Vue.use(VueTilt);
Vue.use(Vuetify);


export default new Vuetify({
    theme: {
      themes:{
        light: {
          primary: '#f15f31',
          secondary: '#002434',
          warning: '#fde1d6',
          info: '#f5f8fc',
          accent: '#516077',
          border: '#96A4B9',
          bluishGrey: '#F5F8FC',
          darkBlue: '#002434'
          
        },
        dark: {
          primary: '#f15f31',
          secondary: '#002434',
          warning: '#fde1d6',
          info: '#f5f8fc',
          accent: '#516077',
          border: '#96A4B9',
          bluishGrey: '#F5F8FC',
          darkBlue: '#002434'
        }
      }
    },
});
